/* MyMagicMemory · gemeinsamer Warenkorb der eigenen Produktseiten (28.09.2026)
   1. lädt je Posten die Druck-SVG + Originalfotos zum Vorschau-Server (/api/vorlage) → Auftrag + Vorschaubild
   2. legt Hauptposten (mit sichtbaren Angaben + _Auftrag/_Vorschau/_Vorlage/_Format) und Zusätze (Rahmen, Sockel)
      in einem Aufruf in den Warenkorb (/cart/add.js)
   3. meldet die Aufträge als „im Warenkorb“ (Schutz vor dem Aufräumen) und öffnet den Warenkorb */
window.MMMKasse = (function(){
  'use strict';
  var API = (window.MMM_KONFIG && window.MMM_KONFIG.api) || 'https://vorschau.mymagicmemory.com';
  try { fetch(API + '/api/status', {credentials:'include'}).catch(function(){}); } catch (e){}
  function hochladen(v){
    var fd = new FormData();
    fd.append('produkt', v.produkt || ''); fd.append('format', v.format || '');
    fd.append('svg', new Blob([v.svg], {type:'image/svg+xml'}), 'vorlage.svg');
    (v.fotos || []).forEach(function(f, i){ if (f) fd.append('foto' + (i + 1), f, f.name || ('foto' + (i + 1) + '.jpg')); });
    return fetch(API + '/api/vorlage', {method:'POST', body:fd, credentials:'include'}).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){ if (!r.ok || !j.auftrag) throw new Error(j.fehler || 'Die Gestaltung konnte nicht übertragen werden. Bitte noch einmal versuchen.'); return j; });
    });
  }
  /* posten: [{variante, menge, eigenschaften:{sichtbar…}, vorlage:{produkt, format, svg, fotos:[File|Blob]},
               teile:[{name:'Poster', vorlage:{…}}],   // weitere Druckteile desselben Postens (z. B. Sterntaufe-Set)
               zusaetze:[{variante, menge, eigenschaften}]}]
     Teile landen als „_Teil <name>“ = Auftrag und „_Teil <name> Format“ am Hauptposten. */
  function bestellen(posten, fortschritt){
    var items = [], auftraege = [];
    return posten.reduce(function(kette, p, i){
      return kette.then(function(){
        if (fortschritt) fortschritt(i + 1, posten.length);
        return hochladen(p.vorlage).then(function(j){
          auftraege.push(j.auftrag);
          var kurz = j.auftrag.slice(0, 8), props = {};
          Object.keys(p.eigenschaften || {}).forEach(function(k){ var w = p.eigenschaften[k]; if (w !== '' && w != null) props[k] = String(w).slice(0, 250); });
          props._Auftrag = j.auftrag; props._Vorschau = API + j.vorschau; props._Vorlage = (p.vorlage.produkt || '') + '-v1'; props._Format = p.vorlage.format || '';
          return (p.teile || []).reduce(function(k2, t){
            return k2.then(function(){ return hochladen(t.vorlage).then(function(tj){
              auftraege.push(tj.auftrag); props['_Teil ' + t.name] = tj.auftrag; props['_Teil ' + t.name + ' Format'] = t.vorlage.format || ''; }); });
          }, Promise.resolve()).then(function(){
          items.push({id:+p.variante, quantity:p.menge || 1, properties:props});
          (p.zusaetze || []).forEach(function(z){ if (!z || !z.variante) return;
            items.push({id:+z.variante, quantity:z.menge || 1, properties:Object.assign({'_Zu Poster':kurz}, z.eigenschaften || {})}); });
          });
        });
      });
    }, Promise.resolve())
    .then(function(){ return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items:items})}); })
    .then(function(r){
      if (!r.ok) return r.json().catch(function(){ return {}; }).then(function(j){ throw new Error(j.description || j.message || 'Der Warenkorb ist gerade nicht erreichbar.'); });
      auftraege.forEach(function(a){ fetch(API + '/api/gekauft/' + a, {method:'POST'}).catch(function(){}); });
      return {auftraege:auftraege, items:items};
    });
  }
  function zumWarenkorb(){ location.href = '/cart'; }
  return {api:API, hochladen:hochladen, bestellen:bestellen, zumWarenkorb:zumWarenkorb};
})();
